import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsAuthenticated } from "@app/store/authSlice";
import { AppState } from "@app/store/store";
import { CompareContent } from "@widgets/compare-content";
import { NoComparisons } from "@widgets/StatusDisplays/NoComparisons";
import { CompareShare } from "@features/compare/CompareShare";
import {
    loadCompareOffersFromLocalStorage,
    selectLocalOfferIds,
    useGetCompareOffersByIdsQuery,
    useGetCompareOffersQuery
} from "@entities/compare";
import { setLocalOffers } from "@entities/compare/model/compareSlice";
import { CustomLoader } from "@shared/ui/CustomLoader";
import { CompareScreenProps } from "./types";
import classes from "./CompareScreen.module.scss";

export const CompareScreen = ({ preloadedData }: CompareScreenProps) => {
    const isShareCompare = Boolean(preloadedData);
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const localOfferIds = useSelector(selectLocalOfferIds);

    const { data: fetchedData, isLoading: isLoadingServer } = useGetCompareOffersQuery(undefined, {
        skip: isShareCompare || !isAuthenticated
    });

    const { data: localData, isLoading: isLoadingLocal } = useGetCompareOffersByIdsQuery(
        localOfferIds,
        { skip: isShareCompare }
    );

    const data = preloadedData
        ? { offers: preloadedData.offers }
        : fetchedData?.offers?.length
          ? fetchedData
          : localData;

    const visibleOffers = data?.offers || [];
    const localOffers = isAuthenticated ? localData?.offers || [] : [];
    const hasData = visibleOffers.length > 0;
    const shouldShowLoader = isLoadingServer || isLoadingLocal;

    const [compareId, setCompareId] = useState(preloadedData ? preloadedData.id : "");

    useEffect(() => {
        if (!isShareCompare) {
            dispatch(setLocalOffers(loadCompareOffersFromLocalStorage()));
        }
    }, [dispatch, isShareCompare]);

    useEffect(() => {
        if (fetchedData?.id) {
            setCompareId(fetchedData.id);
        }
    }, [isLoadingServer]);

    return (
        <div className={classes.compare}>
            <div className={classes.compare__headline}>
                <h1 className={classes.compare__title}>Сравнение автомобилей</h1>
                {isAuthenticated && <CompareShare compareId={compareId} />}
            </div>
            {shouldShowLoader ? (
                <CustomLoader />
            ) : hasData ? (
                <CompareContent
                    visibleOffers={visibleOffers}
                    localOffers={localOffers}
                    compareId={compareId}
                    shouldHideActions={isShareCompare}
                    isAuthenticated={isAuthenticated}
                />
            ) : (
                <div className={classes.compare__status}>
                    <NoComparisons />
                </div>
            )}
        </div>
    );
};